import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';
import type { DailyStatusParams, DailyStatusTicket } from '../../types/workspace';

export function useMyTasksToday(params?: DailyStatusParams, enabled = true) {
  const limit = params?.limit;
  const sort = params?.sort;
  const mine = params?.mine ?? false;

  return useQuery({
    queryKey: ['dashboard-daily-status', limit, sort, mine],
    queryFn: async () => {
      const res = await api.getDailyStatus(params);
      return (res.data ?? []) as DailyStatusTicket[];
    },
    enabled,
    staleTime: 30_000,
  });
}
